<template>
  <UiHeading
    :force-tag="$config.public.seoHeadingStrategy === 'manual' ? 'h3' : undefined"
    class="richtext__h3"
  >
    <slot />
  </UiHeading>
</template>
